import React from "react";
import { motion } from "framer-motion";
import { Shield } from "lucide-react";
import { Button } from "../ui/button";
import { fadeIn, fadeInLeft, fadeInLeftSmall, fadeInRightSmall } from "../../lib/animations";
import { isAdminEmail } from "../../utils/admin";

export function LandingNav({ user, navigate, hasActiveSubscription, logout }) {
  const isAdmin = isAdminEmail(user?.email);
  const isSubscribed = hasActiveSubscription && hasActiveSubscription();

  // Pick the right primary CTA for logged-in users
  let primaryCta = null;
  if (user) {
    if (isAdmin) {
      primaryCta = { label: "Admin Panel", to: "/admin", testId: "landing-admin-btn", icon: Shield };
    } else if (isSubscribed) {
      primaryCta = { label: "Dashboard", to: "/dashboard", testId: "dashboard-btn" };
    } else {
      primaryCta = { label: "Complete Setup", to: "/pricing", testId: "landing-complete-setup-btn" };
    }
  }

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 px-6 md:px-12 lg:px-24 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <motion.a
          href="/"
          {...fadeInLeftSmall}
          className="flex items-center gap-3 cursor-pointer"
          data-testid="logo-link"
        >
          <img src="/images/logo-light.png" alt="AdWup" className="h-10 w-auto" />
        </motion.a>

        <motion.div
          {...fadeInRightSmall}
          className="hidden md:flex items-center gap-6"
        >
          <Button variant="ghost" onClick={() => navigate('/features')} className="text-gray-600 hover:text-[#39FF14] font-medium text-sm transition-colors">Features</Button>
          <Button variant="ghost" onClick={() => navigate('/pricing')} className="text-gray-600 hover:text-[#39FF14] font-medium text-sm transition-colors" data-testid="pricing-btn">Pricing</Button>
          <Button variant="ghost" onClick={() => navigate('/about')} className="text-gray-600 hover:text-[#39FF14] font-medium text-sm transition-colors">About Us</Button>
          <Button variant="ghost" onClick={() => navigate('/blog')} className="text-gray-600 hover:text-[#39FF14] font-medium text-sm transition-colors" data-testid="blog-btn">Blog</Button>
        </motion.div>

        <motion.div
          {...fadeInRightSmall}
          className="flex items-center gap-3"
        >
          {user ? (
            <div className="flex items-center gap-3">
              {primaryCta && (
                <Button
                  onClick={() => navigate(primaryCta.to)}
                  className={
                    isAdmin
                      ? "bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold px-6 shadow-md hover:shadow-lg transition-all"
                      : "bg-[#39FF14] text-black hover:bg-[#32E012] font-semibold px-6"
                  }
                  data-testid={primaryCta.testId}
                >
                  {primaryCta.icon && <primaryCta.icon className="w-4 h-4 mr-2" />}
                  {primaryCta.label}
                </Button>
              )}
              <Button
                variant="ghost"
                onClick={() => { logout(); navigate('/', { replace: true }); }}
                className="text-gray-500 hover:text-red-500 font-medium text-sm"
                data-testid="landing-logout-btn"
              >
                Log Out
              </Button>
            </div>
          ) : (
            <>
              <Button
                variant="ghost"
                onClick={() => navigate('/auth')}
                className="text-gray-600 hover:text-gray-900 font-medium text-sm"
                data-testid="login-btn"
              >
                Log In
              </Button>
              <Button
                onClick={() => navigate('/pricing')}
                className="bg-[#39FF14] text-black hover:bg-[#32E012] font-semibold px-5 py-2"
                data-testid="signup-btn"
              >
                Get Early Access
              </Button>
            </>
          )}
        </motion.div>
      </div>
    </nav>
  );
}
